<template>
  <div class="mini-grid">
    <el-button type="primary" @click="printpage()">打印</el-button>
    <!-- <el-button type="success" @click="start_page()">上一页</el-button>
    <el-button type="success" @click="end_page()">下一页</el-button> -->
    <el-button type="danger" @click="close()">关闭</el-button>
  </div>
</template>

<script>

export default {
  components: { 
  },
  name: "print_fkqkd",
  data() {
    return {
      DJBH:new URLSearchParams(window.location.search).get('JLBH'),
      HSFS:new URLSearchParams(window.location.search).get('HSFS'),
    };
  },
  methods: {
    close(){
        window.close();
    },
    printpage(){
      let printStr = "<html><head><meta http-equiv='Content-Type' content='text/html;charset=utf-8'></head><body>";
      let content = "";
      let sprnstr = "<!--startprint1-->";//设置打印开始区域
      let eprnstr = "<!--endprint1-->";//设置打印结束区域

      let num=$("#ipt_count").val();
      console.log("现在循环数是多少----"+num);
      let str = document.getElementById('model0').innerHTML;     //获取需要打印的页面元素 ，page1元素设置样式page-break-after:always，意思是从下一行开始分割。
      content = content + sprnstr ;

      //纵向：@page { size: portrait; }
      //横向：@page { size: landscape; }    size: 215mm 139mm​;margin: 0mm auto;
      let sss= "<style"+" type="+"text/css"+">"+"@page { size: auto;margin-top: 5mm;margin-left: 10mm;}"+"body{ zoom:70%;padding: 0px 32px; }"+"</style>" ;
      content+=sss;
      if( num==0 ){
          let str = document.getElementById('model0').innerHTML;     //获取需要打印的页面元素 ，page1元素设置样式page-break-after:always，意思是从下一行开始分割。
          content+=str;
      }else{
          for (let i=0;i<num;i++){
              let str = document.getElementById('model'+i).innerHTML;     //获取需要打印的页面元素 ，page1元素设置样式page-break-after:always，意思是从下一行开始分割。
              content+=str;
              if( (i+1)%2==0 ){
                  continue;
              }else{
                  content+="<div"+" style='width:100%;height:150px;'"+"></div>";//加空格
              }

          }
      }


      //str = document.getElementById('model1').innerHTML;     //获取需要打印的页面元素
      content = content + eprnstr;

      printStr = printStr+content+"</body></html>";
      let pwin=window.open("Print.htm","print"); //如果是本地测试，需要先新建Print.htm，如果是在域中使用，则不需要
      pwin.document.write(content);
      pwin.document.close();                   //这句很重要，没有就无法实现
      pwin.print();

      window.location.reload();
    },
    start_page(){
      if( $("#ipt_count").val()==1 ){
          //子表只有一页
          alert("一共只有一页，不存在上一页");
          return;
      }
      if( $("#ipt").val() == 0 ){
          alert("当前页已经是最前一页");
          return;
      }else{
          $("#ipt").val(  $("#ipt").val()-1  );
          let page_number=$("#ipt").val();
          //显示  "model"+$("#ipt").val()，隐藏  "model"+($("#ipt").val()+1)
          document.getElementById("model"+page_number ).style.display="";//显示
          page_number++;
          document.getElementById("model"+page_number ).style.display="none";//隐藏
      }
    },
    end_page(){
      let num=$("#ipt_count").val();
      if( $("#ipt_count").val()==1 || $("#ipt_count").val()==0){
          //子表只有一页
          alert("一共只有一页，不存在下一页");
          return;
      }
      //如果显示的是model0
      if( $("#ipt").val() == num-1 ){
          alert("当前页已经是最后一页");
          return;
      }else{
          let page_number=$("#ipt").val();
          //显示  "model"+$("#ipt").val()，隐藏  "model"+($("#ipt").val()+1)
          document.getElementById("model"+page_number ).style.display="none";//隐藏
          page_number++;
          $("#ipt").val(page_number);
          document.getElementById("model"+page_number ).style.display="";//显示
      }
    },
    showDJ(data,HSFS){
      //定义一个数组来存储子表数据
      let  son_list=new Array();

      let  count = 0;
      if(data[1]==""){
          count = 0;
      }else{
          count = Math.ceil( (data[1].length)/9 );//记录子表数据有几页
      }

      //count=0，代表没有费用明细信息
      if( count == 0){
          let sss="";
          sss+="<table"+" id=tab_0_"+0+" style='width:100%;border-collapse:collapse;'"+"><tr>"+
              "<td "+" colspan=2" +"></td>";
          if( HSFS=="联营" ){
              sss+="<td "+" colspan=2" +"  id=hsfs_jkd"+" style='text-align:center;vertical-align:middle;font-size:20px;'"+"   rowspan=2"+">"+data[0][0].PP+"结款单"+"</td>";//data[0][0].PP
          }
          else if( HSFS=="租赁" ){
              sss+="<td "+" colspan=2" +"  id=hsfs_jkd"+" style='text-align:center;vertical-align:middle;font-size:20px;'"+"   rowspan=2"+">"+HSFS+"结款单"+"</td>";
          }else{
            sss+="<td "+" colspan=2" +"  id=hsfs_jkd"+" style='text-align:center;vertical-align:middle;font-size:20px;'"+"   rowspan=2"+">"+data[0][0].PP+"结款单"+"</td>";//data[0][0].PP
          }
          sss+= "<td "+" colspan=2" +">"+""+"</td>"+
              "</tr>"+
              "<tr>"+
              "<td "+" colspan=2" +" style='font-size:15px;'"+">"+data[0][0].FDNAME+"</td>"+
              "<td "+" colspan=2" +" style='font-size:15px;'"+" align='right'"+">"+data[3][0].RQ+"</td>"+
              "</tr>"+
              "<tr><td"+" colspan=2"+">"+"结算单号:"+data[0][0].JLBH+"</td>"+
              "<td"+">"+"部门:"+data[0][0].DEPT_NAME+"</td>"+
              "<td"+" align=center"+">"+"结算年月:"+data[0][0].YEARMONTH+"</td>"+
              "<td"+" colspan=2"+" align='right'"+">"+"金额单位：（人民币元）"+"</td>"+
              "</tr></table>";
              console.log("HSFS"+HSFS);

              sss+="<table"+"  id=tab_11_"+1+" border='1px'"+" cellpadding="+"0px"+" cellspacing="+"0px"+" style='padding:0px;width:100%;border-collapse:collapse;'"+"><tr><td"+" rowspan=3"+">"+"商户"+"</td>"+
                  "<td"+" align=right"+">"+"商户名称"+"</td>";
          sss+="<td"+" colspan=2"+"  align=left"+">"+data[0][0].NAME+"</td>"+

              "<td"+" align=right"+">"+"品牌名称"+"</td>"+
              "<td"+" colspan=2"+"  align=left"+">"+data[0][0].PP+"</td>"+
              "</tr>"+

              "<tr><td"+" align=right"+">"+"合同号"+"</td>"+
              "<td"+" colspan=2"+"  align=left"+">"+data[0][0].HTH+"</td>"+
              "<td"+" align=right"+">"+"合同期限"+"</td>"+
              "<td"+" colspan=2"+"  align=left"+">"+data[2][0].toString()+"</td>"+
              "</tr>"+

              "<tr><td"+" align=right"+">"+"收款银行"+"</td>"+
              "<td"+" colspan=2"+"  align=left"+">"+""+"</td>"+
              "<td"+" align=right"+">"+"银行账号"+"</td>"+
              "<td"+" colspan=2"+"  align=left"+">"+""+"</td>"+
              "</tr>";

          if( HSFS=="联营" ){
              sss+= "<tr><td"+" rowspan=5"+">"+"销售"+"</td>"+
                  "<td"+" align=right"+">"+"销售总额"+"</td>"+
                  "<td"+" align=left"+">"+data[4][0].YSJE+"</td>"+
                  "<td"+" align=center"+">"+"会员折扣金额"+"</td>"+
                  "<td>"+data[0][0].ZKFTJE+"</td>"+
                  "<td"+" align=center"+">"+"结款账期"+"</td>"+
                  "<td>"+data[0][0].FKTS+"</td>"+
                  "</tr>"+
                  "<tr><td"+" colspan=2"+" align=center"+" style='font-size:15px;'"+">"+"本期开票金额"+"</td>";
          }else if(  HSFS=="租赁" ){
              sss+= "<tr><td"+" rowspan=5"+">"+"销售"+"</td>"+
                  "<td"+" align=right"+" colspan=2"+">"+"销售总额"+"</td>"+
                  "<td"+" align=left"+">"+data[4][0].YSJE+"</td>"+
                  "<td"+" align=center"+">"+"结款账期"+"</td>"+
                  "<td"+" colspan=2"+">"+data[0][0].FKTS+"</td>"+
                  "</tr>"+
                  "<tr><td"+" colspan=2"+" align=center"+" style='font-size:15px;'"+">"+"我司代收销售额"+"</td>";
          }else{
              sss+= "<tr><td"+" rowspan=5"+">"+"销售"+"</td>"+
                  "<td"+" align=right"+">"+"销售总额"+"</td>"+
                  "<td"+" align=left"+">"+data[4][0].YSJE+"</td>"+
                  "<td"+" align=center"+">"+"会员折扣金额"+"</td>"+
                  "<td>"+data[0][0].ZKFTJE+"</td>"+
                  "<td"+" align=center"+">"+"结款账期"+"</td>"+
                  "<td>"+data[0][0].FKTS+"</td>"+
                  "</tr>"+
                  "<tr><td"+" colspan=2"+" align=center"+" style='font-size:15px;'"+">"+"本期开票金额"+"</td>";
          }

          sss+=	"<td"+" align=center"+">"+data[0][0].JSJE+"</td>"+
              "<td"+" colspan=3"+" align=center"+" style='font-size:15px;'"+">"+this.changeMoneyToChinese(data[0][0].JSJE)+"</td>"+
              "</tr>"+

              "<tr><td"+" colspan=2"+" align=center"+" style='font-size:15px;'"+">"+"减：本期费用金额"+"</td>"+
              "<td"+" align=center"+">"+data[0][0].KKJE_FY+"</td>"+
              "<td"+" colspan=3"+" align=center"+" style='font-size:15px;'"+">"+this.changeMoneyToChinese(data[0][0].KKJE_FY)+"</td>"+
              "</tr>"+

              "<tr><td"+" colspan=2"+" align=center"+" style='font-size:15px;'"+">"+"加：本期已交金额"+"</td>"+
              "<td"+" align=center"+">"+data[0][0].FKJE+"</td>"+
              "<td"+" colspan=3"+" align=center"+" style='font-size:15px;'"+">"+this.changeMoneyToChinese(data[0][0].FKJE)+"</td>"+
              "</tr>"+

              "<tr><td"+" colspan=2"+" align=center"+" style='font-size:15px;'"+">"+"本期付款金额"+"</td>"+
              "<td"+" align=center"+">"+data[0][0].YFJE+"</td>"+
              "<td"+" colspan=3"+" align=center"+" style='font-size:15px;'"+">"+this.changeMoneyToChinese(data[0][0].YFJE)+"</td>"+
              "</tr>"+

              "<tr>"+
              "<td>"+"费用明细"+"</td>"+
              "<td" +" colspan=6"+">";
          sss+="<table"+" id=tab_5_"+2+" style='width:100%;height:100%;font-size: 15px;table-layout:fixed;border-collapse:collapse;'"+"><tr>"+
              "<td"+" align=center"+" style='width:5%;white-space: nowrap;'"+">"+"序号"+"</td>"+
              "<td"+" align=center"+" style='width:15%;white-space: nowrap;'"+">"+"费用项目"+"</td>"+
              "<td"+" style='width:9%;white-space: nowrap;'"+">"+"销售金额"+"</td>"+
              "<td"+" style='width:9%;white-space: nowrap;'"+">"+"应交款项"+"</td>"+
              "<td"+" style='width:9%;white-space: nowrap;'"+">"+"已收金额"+"</td>"+
              "<td"+" align=center"+" style='width:53%;white-space: nowrap;'"+">"+"备注"+"</td></tr>";



          sss+="</table></td></tr></table>";

          console.log("data[0][0].ZDRQ-"+data[0][0].ZDRQ);
          sss+="<table"+"  id=tab_123_"+3+"  style='width:100%;border-collapse:collapse;'"+"><tr>";
          sss+="<td"+" align=right"+">"+"制单时间:"+"</td>"+
              "<td"+" align=left"+">"+data[0][0].ZDRQ+"</td>"+
              "<td"+" align=center"+">"+"制单人:"+data[0][0].YWSHRMC+"</td>"+
              "<td>"+""+"</td>"+
              "<td>"+"财务经理1:"+"</td>"+
              "<td>"+"总经理:"+"</td>"+
              "<td"+" align=right"+">"+"第1页/共1页"+"</td>"+
              "</tr>"+
              "<tr>"+

              "</tr>"+
              "<tr>";
            sss+="<td"+"  colspan=5"+" align=right"+" style='font-size:15px;'"+">"+"商户签字或盖章确认:"+"</td>";
            sss+="<td></td>"+
              "<td></td>"+
              "</tr>"+
              "<tr>"+
              "<td"+"  colspan=5"+" align=right"+" style='font-size:15px;'"+">"+"日期:"+"</td>"+
              "<td></td>"+
              "<td></td>"+
              "</tr></table>";

          $("#model"+0).append(sss);

          $("#tab_0_"+0+"  td").css("width","140px");
          $("#tab_0_"+0+"  td").css("height","25px");
          //$("#tab_11_"+p+"  td").css("width","140px");
          //$("#tab_11_"+p+"  td").css("height","25px");
          $("#tab_11_"+1+"  td").css("border","1px solid");
          $("#tab_123_"+3+"  td").css("width","140px");
          $("#tab_123_"+3+"  td").css("height","25px");

      }else{
          for(let p=0;p<count;p++){
              let sss="";

              sss+="<table"+" id=tab_0_"+p+" style='width:100%;border-collapse:collapse;'"+"><tr>"+
                  "<td "+" colspan=2" +"></td>";
              if( HSFS=="联营" ){
                  sss+="<td "+" colspan=2" +"  id=hsfs_jkd"+" style='text-align:center;vertical-align:middle;font-size:20px;'"+"   rowspan=2"+">"+"专柜"+"结款单"+"</td>";//data[0][0].PP
              }
              else if( HSFS=="租赁" ){
                  sss+="<td "+" colspan=2" +"  id=hsfs_jkd"+" style='text-align:center;vertical-align:middle;font-size:20px;'"+"   rowspan=2"+">"+HSFS+"结款单"+"</td>";
              }else{
                  sss+="<td "+" colspan=2" +"  id=hsfs_jkd"+" style='text-align:center;vertical-align:middle;font-size:20px;'"+"   rowspan=2"+">"+"专柜"+"结款单"+"</td>";//data[0][0].PP
              }
              sss+="<td "+" colspan=2" +">"+""+"</td>"+
                  "</tr>"+
                  "<tr>"+
                  "<td "+" colspan=2" +" style='font-size:15px;'"+">"+data[0][0].FDNAME+"</td>"+
                  "<td "+" colspan=2" +" style='font-size:15px;'"+" align='right'"+">"+data[3][0].RQ+"</td>"+
                  "</tr>"+
                  "<tr><td"+" colspan=2"+">"+"结算单号:"+data[0][0].JLBH+"</td>"+
                  "<td"+">"+"部门:"+data[0][0].DEPT_NAME+"</td>"+
                  "<td"+" align=center"+">"+"结算年月:"+data[0][0].YEARMONTH+"</td>"+
                  "<td"+" colspan=2"+" align='right'"+">"+"金额单位：（人民币元）"+"</td>"+
                  "</tr></table>";
                sss+= "<table"+"  id=tab_11_"+p+" border='1px'"+" cellpadding="+"0px"+" cellspacing="+"0px"+" style='padding:0px;width:100%;border-collapse:collapse;'"+"><tr><td"+" rowspan=3"+">"+"商户资料"+"</td>"+
                      "<td"+" align=right"+">"+"商户名称"+"</td>"+
                      "<td"+" colspan=2"+"  align=left"+">"+data[0][0].NAME+"</td>";
              sss+="<td"+" align=right"+">"+"品牌名称"+"</td>"+
                  "<td"+" colspan=2"+"  align=left"+">"+data[0][0].PP+"</td>"+
                  "</tr>"+

                  "<tr><td"+" align=right"+">"+"合同号"+"</td>"+
                  "<td"+" colspan=2"+"  align=left"+">"+data[0][0].HTH+"</td>"+
                  "<td"+" align=right"+">"+"合同期限"+"</td>"+
                  "<td"+" colspan=2"+"  align=left"+">"+data[2][0].toString()+"</td>"+
                  "</tr>"+

                  "<tr><td"+" align=right"+">"+"收款银行"+"</td>"+
                  "<td"+" colspan=2"+"  align=left"+">"+""+"</td>"+
                  "<td"+" align=right"+">"+"银行账号"+"</td>"+
                  "<td"+" colspan=2"+"  align=left"+">"+""+"</td>"+
                  "</tr>";

              if( HSFS=="联营" ){
                  sss+= "<tr><td"+" rowspan=5"+">"+"销售"+"</td>"+
                      "<td"+" align=right"+">"+"销售总额"+"</td>"+
                      "<td"+" align=left"+">"+data[4][0].YSJE+"</td>"+
                      "<td"+" align=center"+">"+"会员折扣金额"+"</td>"+
                      "<td>"+data[0][0].ZKFTJE+"</td>"+
                      "<td"+" align=center"+">"+"结款账期"+"</td>"+
                      "<td>"+data[0][0].FKTS+"</td>"+
                      "</tr>"+
                      "<tr><td"+" colspan=2"+" align=center"+" style='font-size:15px;'"+">"+"本期开票金额"+"</td>";
              }else if(  HSFS=="租赁" ){
                  sss+= "<tr><td"+" rowspan=5"+">"+"销售"+"</td>"+
                      "<td"+" align=right"+" colspan=2"+">"+"销售总额"+"</td>"+
                      "<td"+" align=left"+">"+data[4][0].YSJE+"</td>"+
                      "<td"+" align=center"+">"+"结款账期"+"</td>"+
                      "<td"+" colspan=2"+">"+data[0][0].FKTS+"</td>"+
                      "</tr>"+
                      "<tr><td"+" colspan=2"+" align=center"+" style='font-size:15px;'"+">"+"我司代收销售额"+"</td>";
              }else{
                  sss+= "<tr><td"+" rowspan=5"+">"+"销售"+"</td>"+
                      "<td"+" align=right"+">"+"销售总额"+"</td>"+
                      "<td"+" align=left"+">"+data[4][0].YSJE+"</td>"+
                      "<td"+" align=center"+">"+"会员折扣金额"+"</td>"+
                      "<td>"+data[0][0].ZKFTJE+"</td>"+
                      "<td"+" align=center"+">"+"结款账期"+"</td>"+
                      "<td>"+data[0][0].FKTS+"</td>"+
                      "</tr>"+
                      "<tr><td"+" colspan=2"+" align=center"+" style='font-size:15px;'"+">"+"本期开票金额"+"</td>";
              }

              sss+=	"<td"+" align=center"+">"+data[0][0].JSJE+"</td>"+
                  "<td"+" colspan=3"+" align=center"+" style='font-size:15px;'"+">"+this.changeMoneyToChinese(data[0][0].JSJE)+"</td>"+
                  "</tr>"+

                  "<tr><td"+" colspan=2"+" align=center"+" style='font-size:15px;'"+">"+"减：本期费用金额"+"</td>"+
                  "<td"+" align=center"+">"+data[0][0].KKJE_FY+"</td>"+
                  "<td"+" colspan=3"+" align=center"+" style='font-size:15px;'"+">"+this.changeMoneyToChinese(data[0][0].KKJE_FY)+"</td>"+
                  "</tr>"+

                  "<tr><td"+" colspan=2"+" align=center"+" style='font-size:15px;'"+">"+"加：本期已交金额"+"</td>"+
                  "<td"+" align=center"+">"+data[0][0].FKJE+"</td>"+
                  "<td"+" colspan=3"+" align=center"+" style='font-size:15px;'"+">"+this.changeMoneyToChinese(data[0][0].FKJE)+"</td>"+
                  "</tr>"+

                  "<tr><td"+" colspan=2"+" align=center"+" style='font-size:15px;'"+">"+"本期付款金额"+"</td>"+
                  "<td"+" align=center"+">"+data[0][0].YFJE+"</td>"+
                  "<td"+" colspan=3"+" align=center"+" style='font-size:15px;'"+">"+this.changeMoneyToChinese(data[0][0].YFJE)+"</td>"+
                  "</tr>"+

                  "<tr>"+
                  "<td>"+"费用明细"+"</td>"+
                  "<td" +" colspan=6"+">";
              sss+="<table"+" id=tab_5_"+p+" style='width:100%;height:100%;font-size: 15px;table-layout:fixed;border-collapse:collapse;'"+"><tr>"+
                  "<td"+" align=center"+" style='width:5%;white-space: nowrap;'"+">"+"序号"+"</td>"+
                  "<td"+" align=center"+" style='width:15%;white-space: nowrap;'"+">"+"费用项目"+"</td>"+
                  "<td"+" style='width:9%;white-space: nowrap;'"+">"+"销售金额"+"</td>"+
                  "<td"+" style='width:9%;white-space: nowrap;'"+">"+"应交款项"+"</td>"+
                  "<td"+" style='width:9%;white-space: nowrap;'"+">"+"已收金额"+"</td>"+
                  "<td"+" align=center"+" style='width:53%;white-space: nowrap;'"+">"+"备注"+"</td></tr>";

              let  son_suju="";//子表数据
              for(let i=0;i<data[1].length;i++){
                  if(data[1][i].BZ==null){
                      data[1][i].BZ="";
                  }

                  if( p==0 ){
                      if(i<9){
                          son_suju+="<tr><td"+" align=center"+" style='width:5%'"+">"+data[1][i].INX+"</td>"+
                              "<td"+" style='width:15%;white-space: nowrap;'"+">"+data[1][i].SFXMMC+"</td>"+
                              "<td"+" align=right"+" style='width:9%'"+">"+data[1][i].XSJE+"</td>"+
                              "<td"+" align=right"+" style='width:9%'"+">"+data[1][i].KKJE+"</td>"+
                              "<td"+" align=right"+" style='width:9%'"+">"+data[1][i].YSJE+"</td>"+
                              "<td"+" style='width:53%;white-space: nowrap;overflow:hidden;'"+">"+data[1][i].BZ+"</td></tr>";
                      }else{
                          continue;
                      }
                  }

                  if( p!=0 ){
                      if( i< p*9 ){
                          continue;
                      }
                      if(i>=p*9 && i<(p+1)*9 ){
                          son_suju+="<tr><td"+" align=center"+" style='width:5%'"+">"+data[1][i].INX+"</td>"+
                              "<td"+" style='width:15%;white-space: nowrap;'"+">"+data[1][i].SFXMMC+"</td>"+
                              "<td"+" align=right"+" style='width:9%'"+">"+data[1][i].XSJE+"</td>"+
                              "<td"+" align=right"+" style='width:9%'"+">"+data[1][i].KKJE+"</td>"+
                              "<td"+" align=right"+" style='width:9%'"+">"+data[1][i].YSJE+"</td>"+
                              "<td"+" style='width:53%;white-space: nowrap;overflow:hidden;'"+">"+data[1][i].BZ+"</td></tr>";
                      }else{
                          continue;
                      }
                  }
              }

              sss+=son_suju+"</table></td></tr></table>";

              if((p+1)%2==0){
                  console.log("我进来分页了，这个时候p等于"+p);
                  sss+="<table"+"  id=tab_123_"+p+"  style='width:100%;page-break-after:always;border-collapse:collapse;'"+"><tr>";
              }else{
                  sss+="<table"+"  id=tab_123_"+p+"  style='width:100%;border-collapse:collapse;'"+"><tr>";
              }
              console.log("data[0][0].ZDRQ-"+data[0][0].ZDRQ);
              sss+="<td"+" align=right"+">"+"制单时间:"+"</td>"+
                  "<td"+" align=left"+">"+data[0][0].ZDRQ+"</td>"+
                  "<td"+" align=center"+">"+"制单人:"+data[0][0].YWSHRMC+"</td>"+
                  "<td>"+""+"</td>"+
                  "<td>"+"财务经理2:"+"</td>"+
                  "<td>"+"总经理:"+"</td>"+
                  "<td"+" align=right"+">"+"第"+(p+1)+"页/共"+count+"页"+"</td>"+
                  "</tr>"+
                  "<tr>"+

                  "</tr>"+
                  "<tr>";
                sss+= "<td"+"  colspan=5"+" align=right"+" style='font-size:15px;'"+">"+"商户签字或盖章确认:"+"</td>";
                sss+="<td></td>"+
                  "<td></td>"+
                  "</tr>"+
                  "<tr>"+
                  "<td"+"  colspan=5"+" align=right"+" style='font-size:15px;'"+">"+"日期:"+"</td>"+
                  "<td></td>"+
                  "<td></td>"+
                  "</tr></table>";

              $("#model"+p).append(sss);

              $("#tab_0_"+p+"  td").css("width","140px");
              $("#tab_0_"+p+"  td").css("height","25px");
              //$("#tab_11_"+p+"  td").css("width","140px");
              //$("#tab_11_"+p+"  td").css("height","25px");
              $("#tab_11_"+p+"  td").css("border","1px solid");
              $("#tab_123_"+p+"  td").css("width","140px");
              $("#tab_123_"+p+"  td").css("height","25px");
          }
      }
    },
    changeMoneyToChinese(money){
      let cnNums = new Array("零","壹","贰","叁","肆","伍","陆","柒","捌","玖"); //汉字的数字
      let cnIntRadice = new Array("","拾","佰","仟"); //基本单位
      let cnIntUnits = new Array("","万","亿","兆"); //对应整数部分扩展单位
      let cnDecUnits = new Array("角","分","毫","厘"); //对应小数部分单位
      let cnInteger = "整"; //整数金额时后面跟的字符
      let cnIntLast = "元"; //整型完以后的单位
      let maxNum = 999999999999999.9999; //最大处理的数字

      let IntegerNum; //金额整数部分
      let DecimalNum; //金额小数部分
      let ChineseStr=""; //输出的中文金额字符串
      let parts; //分离金额后用的数组，预定义
      if( money === "" ){
          return "";
      }

      money = parseFloat(money);

      if( money >= maxNum ){
          $.alert('超出最大处理数字');
          return "";
      }

      if( money==0 ){
          ChineseStr = cnNums[0]+cnIntLast+cnInteger;
          return ChineseStr;
      }
      money = money.toString(); //转换为字符串
      if( money.indexOf(".") == -1 ){
          IntegerNum = money;
          DecimalNum = '';
      }else{
          parts = money.split(".");
          IntegerNum = parts[0];
          DecimalNum = parts[1].substr(0,4);
      }
      if( parseInt(IntegerNum,10) > 0 ){//获取整型部分转换
          let zeroCount = 0;
          let IntLen = IntegerNum.length;
          for(let  i=0;i<IntLen;i++ ){
              let n = IntegerNum.substr(i,1);
              let p = IntLen - i - 1;
              let q = p / 4;
              let m = p % 4;
              if( n == "0" ){
                  zeroCount++;
              }else{
                  if( zeroCount > 0 ){
                      ChineseStr += cnNums[0];
                  }
                  zeroCount = 0; //归零
                  ChineseStr += cnNums[parseInt(n)]+cnIntRadice[m];
              }
              if( m==0 && zeroCount<4 ){
                  ChineseStr += cnIntUnits[q];
              }
          }
          ChineseStr += cnIntLast;
          //整型部分处理完毕
      }
      if( DecimalNum!= '' ){//小数部分
          let decLen = DecimalNum.length;
          for(let  i=0; i<decLen; i++ ){
              let n = DecimalNum.substr(i,1);
              if( n != '0' ){
                  ChineseStr += cnNums[Number(n)]+cnDecUnits[i];
              }
          }
      }
      if( ChineseStr == '' ){
          //ChineseStr += cnNums[0]+cnIntLast+cnInteger;
          ChineseStr += cnNums[0]+cnIntLast;
      }

      if( money.substring(money.length-2,money.length-1)===0   ){
          ChineseStr+='整';
      }
      return ChineseStr;
    }
  },
  mounted(){
    this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/searchDJH?DJBH="+this.DJBH).then(resp=>{
            let ipt="<input type="+"hidden"+" id="+"ipt"+" value="+"0"+">";    //这个input输入框也要隐藏，他的  value 代表是第几页（0代表第一页，默认为0）
            let ipt_count="<input"+" id=ipt_count"+" value="+"0"+" type="+"hidden"+">";//需要隐藏的input ,这个 input 的value是 代表费用子表的记录页数
            let div_hidden="<div"+" id=model_hidden"+"></div>";//需要隐藏的div
            let div_box="<div"+" id="+"div_box"+"></div>";
            $(".mini-grid").append(ipt);
            $(".mini-grid").append(ipt_count);
            $(".mini-grid").append(div_hidden);
            $(".mini-grid").append(div_box);
            let data = resp.data.data;
            console.log(this.DJBH+"-------"+this.HSFS);
            //根据单据号 ，查询后台获取到  费用子表 的记录条数
            console.log("data---"+data);
            let  count=0;
            if(data[1]==""){
                count = 0;
                console.log("我进来了----"+count);
            }else{
                count = Math.ceil( (data[1].length)/9 );//记录子表数据有几页
            }
            console.log(data[1].length+"------"+count);
            //设置 计数div 的value 为 count
            $("#ipt_count").val(count);
            if(count==0){
                let div1="<div"+" class="+"preview"+"  id=model0"+" name="+"model"+"></div>";  //存放单据第一页
                $(".mini-grid").append(div1);
            }else{
                for(let i=0;i<count;i++	){
                    if(i==0){    //默认显示第一页
                        let div1="<div"+" class="+"preview"+"  id=model0"+" name="+"model"+"></div>";  //存放单据第一页
                        $(".mini-grid").append(div1);
                    }else{
                        let div_other="<div"+" class="+"preview"+" id=model"+i+" name="+"model"+" style='display:none'"+"></div>";  //存放单据第二页 或者 其他页
                        $(".mini-grid").append(div_other);
                    }
                }
            }
            this.showDJ(data,this.HSFS);
    });
  }
};
</script>

<style lang="scss" scoped>


</style>